import * as React from "react";
const SvgFiRrCloudSleet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-sleet_svg__a)">
      <path
        fill="#062147"
        d="M14 24a1 1 0 0 1-.929-1.372l2-5a1 1 0 0 1 1.858.744l-2 5A1 1 0 0 1 14 24m-4 0q-.192-.001-.372-.071a1 1 0 0 1-.557-1.3l2-5a1.003 1.003 0 0 1 1.629-.344 1 1 0 0 1 .23 1.088l-2 5A1 1 0 0 1 10 24m-4 0q-.192-.001-.372-.071a1 1 0 0 1-.557-1.3l2-5a1.001 1.001 0 0 1 1.858.744l-2 5A1 1 0 0 1 6 24m-2.559-4.5a1 1 0 0 1-.457-.111 5.535 5.535 0 0 1-1.184-8.96 1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.888A7.95 7.95 0 0 1 8.5.137a8.06 8.06 0 0 1 8.734 4.44 1.04 1.04 0 0 0 .743.569c6.68 1.257 8.211 10.478 2.3 13.834a1 1 0 1 1-1.007-1.727c4.327-2.41 3.188-9.272-1.687-10.147a3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.11 9.148a3 3 0 0 1-.964 2.762 3.523 3.523 0 0 0 .754 5.7 1 1 0 0 1-.459 1.89m9.8-4.467a1 1 0 0 1-.868-.5L11.5 13.01l-.873 1.524a1 1 0 1 1-1.735-1L9.774 12H8a1 1 0 1 1 0-2h1.774l-.882-1.54a1.001 1.001 0 0 1 1.735-1l.873 1.53.874-1.524a1 1 0 0 1 1.734 1L13.228 10H15a1 1 0 1 1 0 2h-1.773l.881 1.539a1 1 0 0 1-.866 1.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-sleet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudSleet;
